export default __webpack_public_path__ + "static/dinakajoy5-4e90ad0180ba9ebeedb6b0af7e49937b.png";